import dynamic from 'next/dynamic';
const FontAwesomeIcon = dynamic(
  () => import('@fortawesome/react-fontawesome').then((mod) => mod.FontAwesomeIcon),
  { ssr: true },
);

export default function FontAwesome(props) {
  return (
    <FontAwesomeIcon
      {...props}
    />
  );
}
